import { AuthService } from '../../infrastructure/services/auth.service';
import { ItemLibraryService } from '../../infrastructure/services/itemLibrary.service';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { cpus } from 'os';
import { group } from '@angular/core/src/animation/dsl';
import { ItemLibrary } from 'app/infrastructure/model/classes/itemLibrary.class';

interface FilterItem {
  value: string;
  selected: boolean;
}

interface Filter {
  country: FilterItem[];
  type: FilterItem[];
  insurance: FilterItem[];
}

@Component({
  selector: 'app-desktop',
  templateUrl: './item-library-list.component.html',
  styleUrls: ['./item-library-list.component.css'],
})
export class ItemLibraryListComponent implements OnInit {
  @Input() codsistema: string;

  libraries: ItemLibrary[] = [];
  filteredLibraries: any[] = [];
  isLoading: Boolean = true;
  selectedLibrary: ItemLibrary = null;
  selectedLibraryId: string = null;
  insurances: any;
  groups: any[] = [];
  search = '';
  filters: Filter;

  @Output() onSelect: EventEmitter<ItemLibrary> = new EventEmitter<ItemLibrary>();

  constructor(private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private router: Router,
    public itemLibraryService: ItemLibraryService) { }

  ngOnInit() {
    this.itemLibraryService
      .getAll()
      .subscribe((libraries: ItemLibrary[]) => {
        this.libraries = libraries;
        this.libraries.forEach(library => {
          let extraInfo = JSON.parse(library.extraInfo);
          library.country = extraInfo.country;
          library.origen = extraInfo.origen;
          library.category = extraInfo.category;
          library.description = extraInfo.description;
          library.insurance = extraInfo.insurance;
        });
        this.isLoading = false;
        this.grouping();
        this.resetFilters();
      });
  }

  grouping() {
    let objGroup = _(this.libraries).groupBy(library => library.category).value();
    let iterableGroup = Object.keys(objGroup).map((k) => objGroup[k]);
    iterableGroup.forEach(group => {
      this.groups.push(group);
    });
    this.filteredLibraries = this.groups;
  }

  clickEdit() {
    this.router.navigate(['.', this.selectedLibraryId], { relativeTo: this.aRoute });
  }

  clickImport() {
    this.router.navigate(['.', this.selectedLibraryId, 'import'], { relativeTo: this.aRoute });
  }

  selectLibrary(library: ItemLibrary) {
    this.selectedLibraryId = library.id;
    this.selectedLibrary = library;
  }

  open(content) {
    // Back-up filters
    const copyFilters = _.cloneDeep(this.filters);

    this.modalService.open(content).result.then((result) => {
      this.applyFilter();
    }, (reason) => {
      // In case of dismiss or cancel, restore filters from backup
      this.filters = _.cloneDeep(copyFilters);
    });
  }

  resetFilters() {
    this.filters = {
      country: [],
      insurance: [],
      type: []
    };

    this.filteredLibraries.forEach(library => {
      library.forEach(item => {
        this.addIfNotExists(this.filters.country, item.country);
        this.addIfNotExists(this.filters.type, item.origen);
        this.addIfNotExists(this.filters.insurance, item.insurance);
      });
    });
  }

  addIfNotExists(collection: FilterItem[], value: string) {
    const exists = collection.find(item => item.value === value);
    if (!exists) {
      collection.push({ value, selected: true });
    }
  }

  applyFilter() {
    this.applySearch();

    //Options Selected
    const selectedCountry = this.filters.country.filter(filter => filter.selected)
      .map(filter => filter.value);
    const selectedType = this.filters.type.filter(filter => filter.selected)
      .map(filter => filter.value);
    const selectedInsurance = this.filters.insurance.filter(filter => filter.selected)
      .map(filter => filter.value);
      
    //Filter
    let categorias = [];
    this.groups.forEach(group => {

      group = group.filter(p =>{
        return selectedCountry.includes(p.country) &&
          selectedType.includes(p.origen) &&
          selectedInsurance.includes(p.insurance);
      });

        if(group.length > 0) {
          categorias.push(group);
        }        
    });

    this.groups = categorias;
  }

  librarySelected(library: ItemLibrary) {
    this.selectedLibrary = library;
  }

  applySearch() {
    this.groups = this.filteredLibraries;
  }

  volver(){
    this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/item-library/item-library-list.component.ts